:host {
  display: inline-block;
}

:host * {
  align-items: center;
  height: 18px;
  font-family: var(--dc-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.01px;
}

.dc-breadcrumb {
  display: flex;
  text-decoration: none;
  padding-right: 8px;
}

.dc-text {
  text-decoration: none;
  color: var(--dc-primary-colour);
  display: inline-block;
  position: relative;
}

.dc-text::before {
  content: " ";
  position: absolute;
  transform: scaleX(0);
  width: 0;
  height: 1px;
  left: 0;
  bottom: 0;
  right: 0;
  transition: transform 0.25s ease-out;
}

.dc-text:hover::before {
  width: 100%;
  transform: scaleX(1);
  transform-origin: bottom left;
  cursor: pointer;
  background-color: var(--dc-secondary-colour);
}

.dc-text:hover {
  color: var(--dc-primary-accent-colour);
}

.dc-breadcrumb-icon {
  padding-left: 8px;
  width: 6px;
  height: 10px;
}

.dc-breadcrumb-icon path {
  fill: var(--dc-greyscale-04);
}

.dc-text:focus-visible {
  outline: none;
  text-underline-offset: 3px;
  text-decoration: 3px solid  underline;
}

.dc-current {
  display: flex;
  color: var(--dc-primary-text-color);
}
